import { EDigestPreference } from '@/graphql-types/globalTypes';

export const recordDetailText = (jobTitle: string, company: string): string => {
  return jobTitle && company
    ? `${jobTitle}, ${company}`
    : jobTitle
    ? `${jobTitle}`
    : company
    ? `${company}`
    : '';
};

export const eventNavBlockingText =
  'Navigating away from this page means you will leave this event. Are you sure you want to do this?';

export const DIGEST_PREFERENCE_OPTIONS = [
  {
    text: 'Off',
    value: EDigestPreference.OFF,
  },
  {
    text: 'Realtime',
    value: EDigestPreference.REALTIME,
  },
  {
    text: 'Daily',
    value: EDigestPreference.DAILY,
  },
  {
    text: 'Weekly',
    value: EDigestPreference.WEEKLY,
  },
];
